:host {
  display: block;
  margin: 0 auto;
  width: fit-content;
}
